module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website-w960.a3d58dbe.jpg";